export default "__VITE_ASSET__a19a06d1__"